<template>
  <div
    class="services-wrapper "
    v-if="_.get(itemData, 'data')"
    :class="colorData ">
    <intersect @enter="animate = true">
    <div class="container">

        <h3 class="ttl fadeUp" v-if="_.get(itemData, 'conf.useHeader') == 1" :class="animate ? 'animate' : '' ">
          {{ _.get(itemData, "conf.header.title") }}
        </h3>
        <div class="fadeUp" :class="animate ? 'animate' : '' ">
          <div class="services-slider-wrap " >
            <swiper
              ref="mySwiper"
              :options="swiperOptions"
              class="services-slider"
              :class="itemData.data.length < 3 ? 'two' : ''"
            >
              <swiper-slide v-for="(slide, index) in itemData.data" :key="index">
                <a
                  :href="_.get(slide, 'smartbuttons[0].url')"
                  class="service-box"
                  v-if="slide.smartbuttons"
                >
                  <div class="top">
                    <h2 class="noto-semibold ttl">{{ _.get(slide, "title") }}</h2>
                    <div class="icon">
                      <img
                        v-if="_.get(slide, 'icon_image.0.url')"
                        :src="_.get(slide, 'icon_image.0.url')"
                        alt
                      />
                    </div>
                  </div>

                  <div class="txt">{{ _.get(slide, "teaser") }}</div>

                  <div class="bottom">
                    <div class="line-wrap">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="726.5"
                        height="0.5"
                        viewBox="0 0 726.5 0.5"
                      >
                        <line
                          id="Line_27"
                          data-name="Line 27"
                          x2="726"
                          transform="translate(0.25 0.25)"
                          fill="none"
                          stroke="#bcbec0"
                          stroke-linecap="round"
                          stroke-width="0.5"
                          stroke-dasharray="10"
                        />
                      </svg>
                    </div>

                    <div class="whiteRed-btn" v-if="_.get(slide, 'smartbuttons')">
                      <span class="noto-semibold">{{
                        _.get(slide, "smartbuttons.0.title")
                      }}</span>
                    </div>
                  </div>
                </a>
              </swiper-slide>

              <div class="services-button-prev" slot="button-prev">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.013"
                  height="21.906"
                  viewBox="0 0 12.013 21.906"
                >
                  <g
                    id="Group_70"
                    data-name="Group 70"
                    transform="translate(42.561 -19626.655) rotate(-90)"
                  >
                    <path
                      id="Path_61"
                      data-name="Path 61"
                      d="M0,9.892,9.892,0"
                      transform="translate(-19637.607 -41.5)"
                      fill="none"
                      stroke="#444958"
                      stroke-linecap="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_60"
                      data-name="Path 60"
                      d="M9.892,9.892,0,0"
                      transform="translate(-19647.5 -41.5)"
                      fill="none"
                      stroke="#444958"
                      stroke-linecap="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
              </div>
              <div class="services-button-next" slot="button-next">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.013"
                  height="21.906"
                  viewBox="0 0 12.013 21.906"
                >
                  <g
                    id="Group_70"
                    data-name="Group 70"
                    transform="translate(42.561 -19626.655) rotate(-90)"
                  >
                    <path
                      id="Path_61"
                      data-name="Path 61"
                      d="M0,9.892,9.892,0"
                      transform="translate(-19637.607 -41.5)"
                      fill="none"
                      stroke="#444958"
                      stroke-linecap="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_60"
                      data-name="Path 60"
                      d="M9.892,9.892,0,0"
                      transform="translate(-19647.5 -41.5)"
                      fill="none"
                      stroke="#444958"
                      stroke-linecap="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
              </div>
            </swiper>
          </div>
        </div>
    </div>
    </intersect>
  </div>
</template>

<script>
import Intersect from 'vue-intersect'
export default {
  components: {
    Intersect
  },
  props: ["itemData", "colorData"],
  data() {
    return {
      swiperOptions: {},
      animate: false,
      animate2: false,
    };
  },

  beforeMount() {
    this.slider();
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },

    slidesList: function () {
      return this.itemData;
    },
  },

  methods: {
    slider: function () {
      if (this.itemData.data.length < 3) {
        this.swiperOptions = {
          speed: 800,
          spaceBetween: 20,
          watchOverflow: true,
          slidesPerView: "auto",
          navigation: {
            nextEl: ".services-button-next",
            prevEl: ".services-button-prev",
          },
          breakpoints: {
            320: {
              spaceBetween: 15,
              slidesPerView: this.itemData.data.length > 1 ? 1.3 : 1,
            },
            768: {
              spaceBetween: 15,
              slidesPerView: "auto",
            },
            1024: {
              spaceBetween: 15,
              slidesPerView: "auto",
            },
            1366: {
              spaceBetween: 15,
              slidesPerView: "auto",
            },
            1599: {
              spaceBetween: 15,
              slidesPerView: "auto",
            },
            1900: {
              spaceBetween: 15,
              slidesPerView: "auto",
            },
          },
        };
      } else {
        this.swiperOptions = {
          speed: 800,
          spaceBetween: 20,
          watchOverflow: true,
          slidesPerView: 3,
          navigation: {
            nextEl: ".services-button-next",
            prevEl: ".services-button-prev",
          },
          breakpoints: {
            320: {
              spaceBetween: 15,
              slidesPerView: 1.2,
            },
            768: {
              spaceBetween: 15,
              slidesPerView: 2,
            },
            1024: {
              spaceBetween: 15,
              slidesPerView: 3,
            },
            1366: {
              spaceBetween: 15,
              slidesPerView: 3,
            },
            1599: {
              spaceBetween: 15,
              slidesPerView: 3,
            },
            1900: {
              spaceBetween: 15,
              slidesPerView: 3,
            },
          },
        };
      }
    },
  },
};
</script>
